<script>
import { defineComponent, computed } from 'vue'
import { Bar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default defineComponent({
  name: 'BarChart',
  components: { Bar },
  props: {
    labels: {
      type: Array,
      required: true
    },
    values: {
      type: Array,
      required: true
    },
    f1Values: {
      type: Array,
      required: true
    },
    f2Values: {
      type: Array,
      required: true
    },
    f3Values: {
      type: Array,
      required: true
    },
    chartTitle: {
      type: String,
      default: ' '
    },
    type: {
      type: String,
      default: 'ee'
    }
  },
  setup(props) {
  console.log('Labels:', props.labels)
  console.log('Values:', props.values)

  console.log('f1 Values:', props.f1Values)
  console.log('f2 Values:', props.f2Values)
  console.log('f3 Values:', props.f3Values)



    const chartData = computed(() => ({
      labels: props.labels,
      datasets:  props.type === 'ee' ? [
            {
      label: 'F1',
      backgroundColor: '#E0C821',
      hoverBackgroundColor: '#E0C821',
      data: props.f1Values
    },
     {
      label: 'F2',
      backgroundColor: '#F19711',
      hoverBackgroundColor: '#F19711',
      data: props.f2Values
    },
       {
      label: 'F3',
      backgroundColor: '#943D09',
      hoverBackgroundColor: '#943D09',
      data: props.f3Values
    }
      ] : [
        {
          label: 'Consumi',
          backgroundColor: '#2279c1',
          data: props.values
        }
      ]
    }))

    const chartOptions = computed(() => ({
      responsive: true,
      plugins: {
        title: {
          display: true,
          text: props.chartTitle
        },
        legend: {
          position: 'top',
          labels: {
            sort: (a, b) => a.text.localeCompare(b.text)
          }
        }
      },
      scales: {
    x: {
      stacked: true,
        ticks: {
        callback: function (val) {
          const label = this.getLabelForValue(val)
          const parts = label.split('_')
          return [`${parts[0]}`, parts[1]]
        }
      }
    },
    y: {
      stacked: true,
      beginAtZero: true
    }
  }
    }))

    return {
      chartData,
      chartOptions
    }
  }
})
</script>

<template>
  <Bar 
  v-if="labels.length && (values.length || (f1Values.length > 0 && f2Values.length > 0 && f3Values.length > 0))"
  :data="chartData" :options="chartOptions" />
</template>

